var base = require('settings/teams/team-members');

Vue.component('spark-team-members', {
    mixins: [base],

    data() {
        return{
            update_modal: false,
            delete_modal: false
        };
    },

    computed: {
        tableheaders: function(){
            var tableheaders = [];
            tableheaders.push({
                value: 'photo',  align: 'left', sortable: false
            });
            tableheaders.push({
                text: 'Name', value: 'name',  align: 'left'
            });
            if(typeof this.roles !== 'undefined' && this.roles.length > 1){
                tableheaders.push({
                    text: 'Role', value: 'role_id',  align: 'left', sortable: false
                });
            }
            tableheaders.push({
                value: 'edit', sortable: false
            });
            tableheaders.push({
                value: 'delete', sortable: false
            });
            return tableheaders;

        }
    },

    methods: {

        /**
         * Edit the given team member.
         */
        editTeamMember(member) {
            this.updatingTeamMember = member;
            this.updateTeamMemberForm.role = member.pivot.role;

            //$('#modal-update-team-member').modal('show');
            this.update_modal = true;
        },


        /**
         * Update the team member.
         */
        update() {
            var self = this;
            Spark.put(this.urlForUpdating, this.updateTeamMemberForm)
                .then(() => {
                    Bus.$emit('updateTeam');

                    //$('#modal-update-team-member').modal('hide');
                    self.update_modal = false;
                });
        },


        /**
         * Display the approval modal for the deletion of a team member.
         */
        approveTeamMemberDelete(member) {
            this.deletingTeamMember = member;

            //$('#modal-delete-member').modal('show');
            this.delete_modal = true;
        },


        /**
         * Delete the given team member.
         */
        deleteMember() {
            var self = this;
            Spark.delete(this.urlForDeleting, this.deleteTeamMemberForm)
                .then(() => {
                    Bus.$emit('updateTeam');

                    //$('#modal-delete-member').modal('hide');
                    self.delete_modal = false;
                });
        }
    }
});
